import useViewsSelector from "views/stores/useViewsSelector";
import { selectWidgets } from "views/logic/slices/viewSelectors";
const useWidgets = () => useViewsSelector(selectWidgets);
export default useWidgets;
